import type { ReactNode } from 'react';

/** A whole-page status or error (loading a design, "ไม่พบหน้านี้", sign-in problems). */
export function FullPageMessage({ title, message, busy, children }: { title: string; message?: string; busy?: boolean; children?: ReactNode }) {
  return (
    <div className="xc-fullmsg" role={busy ? 'status' : 'alert'}>
      {busy && <span className="xc-spinner" aria-hidden="true" />}
      <h1>{title}</h1>
      {message && <p>{message}</p>}
      {children}
    </div>
  );
}
